import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';

import { LanguagePreferenceService } from '../services/language-preference.service';
import { TranslationGeneralService } from '../translation/translation.general.service';
import { NavigationService } from '../../whoo/core/navigation.service';

/**
 * Sprach-MatMenu fuer das Hamburger-Submenu (Konzept §2 Baustein 2, §8.5):
 * die 6 Sprachen als native Namen, aktive Sprache mit Haekchen. Die Component
 * stellt nur das Menu bereit; der Trigger ist der Hamburger-Eintrag
 * "Sprache: {aktuelle Sprache}" in `menu-button.component.html`. Die Website
 * hat stattdessen einen Header-Globe
 * (`whocan-website/src/components/LanguageSwitcher.astro`).
 */
@Component({
    selector: 'nav-language-menu',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatMenuModule],
    templateUrl: './language-menu.component.html',
    styleUrls: ['./language-menu.component.scss'],
})
export class LanguageMenuComponent {
    @ViewChild(MatMenu, { static: true }) menu: MatMenu;

    constructor(
        public trans: TranslationGeneralService,
        private languagePreference: LanguagePreferenceService,
        private navigation: NavigationService,
    ) { }

    public get currentLanguage(): string {
        return this.trans.local;
    }

    /** Nativer Name der aktiven Sprache (z.B. "Deutsch") fuer den Submenu-Trigger. */
    public get currentLanguageName(): string {
        return this.trans.languages.find((language) => language.id === this.currentLanguage)?.name ?? '';
    }

    /** Explizite Wahl: Praeferenz (+ DbUser.language) schreiben, dann kontexterhaltend wechseln. */
    public async selectLanguage(languageCode: string): Promise<void> {
        await this.languagePreference.choose(languageCode);
        this.navigation.openWindowLanguage(languageCode);
    }
}
